import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IRetornoBuscaCEPModel } from '../model/buscaCEP.model';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from './localstorage.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class BuscaCEPService {

  public usuario!: LoginModel;


  constructor(private http: HttpClient, private localStorageService: LocalStorageService) { 
    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  buscaCEP(cep: string) : Observable<IRetornoBuscaCEPModel>{
    
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaCEP;

    let queryParams = new HttpParams();

    queryParams = queryParams.append("guid",this.usuario.retorno.guid);
    queryParams = queryParams.append("cep",cep);

    return this.http.get<IRetornoBuscaCEPModel>(url, {params: queryParams, headers: new HttpHeaders({ 'Content-Type': 'application/json' })});
  }
  
}


